<template>
  <el-dialog :visible.sync="showDialog">
    <template #title>
      <h4>{{$t('处理举报')}}</h4>
    </template>

    <el-form label-width="120px" ref="form" :model="formData" :rules="rules">
      <el-form-item :label="$t('举报编号')">
        <el-input :value="formData.num" disabled />
      </el-form-item>

      <el-form-item :label="reportLabel">
        <el-input type="textarea" :value="content" disabled :rows="5" />

        <div v-if="picList.length" class="fb-link-flex">
          <img class="el-image" v-for="(pic, index) in picList" :key="index" :src="pic" />
        </div>
      </el-form-item>

      <el-form-item :label="$t('审核意见')">
        <el-radio-group v-model="formData.status" disabled>
          <el-radio label="toHandle">{{$t('审核通过')}}</el-radio>
          <el-radio label="auditNoPass">{{$t('审核不通过')}}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('审核备注')">
        <el-input type="textarea" :placeholder="$t('审核备注')" :rows="4" v-model="formData.remark" disabled />
      </el-form-item>

      <el-form-item :label="$t('处理结果')" prop="handleStatus">
        <el-radio-group v-model="formData.handleStatus">
          <template v-if="currentRow.type === 'account'">
            <el-radio label="bandAccount">{{$t('禁用账号')}}</el-radio>
            <el-radio label="bandCb">{{$t('禁用发布菜谱')}}</el-radio>
            <el-radio label="bandCommunity">{{$t('禁用社区')}}</el-radio>
          </template>
          <el-radio label="delete" v-else>{{$t('删除内容')}}</el-radio>

        </el-radio-group>
      </el-form-item>


    </el-form>

    <template #footer>
      <el-button type="primary" @click="handleConfirm">{{$t('确定')}}</el-button>
      <el-button @click="resetForm">{{$t('重置')}}</el-button>
    </template>

  </el-dialog>
</template>

<script>
import {request} from "@/config/request";

// 举报类型
const REPORT_TYPE = {
  dynamics: {
    contentKey: "dynamicsContent",
    picKey: "",
    label: "被举报动态内容",
  },
  comment: {
    contentKey: "commentContent",
    picKey: "",
    label: "被举报评论内容",
  },
  cookbook: {
    contentKey: "cookbookNum",
    picKey: "",
    label: "被举报菜谱编号",
  },
  account: {
    contentKey: "beReportUserNum",
    picKey: "",
    label: "被举报者编号",
  },
}

export default {
  name: "ReportDisposeForm",
  data() {
    return {
      showDialog: false,
      formData: {
        handleStatus: "",
        remark: '',
      },
      rules: {
        handleStatus: {required: true, message: this.$t('请选择处理状态'), trigger: 'change'}
      },
      currentRow: {}
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate(async valid => {
        if(!valid) return;
        try {
          const params = Object.assign(this.currentRow, this.formData);
          delete params.createTime;
          delete params.updateTime;
          params.status = "finish";
          await request(this.$api.report.updateStatus, params);
          this.$message.success(this.$t('操作成功'));
          this.showDialog = false;
          this.$emit("refresh");
        } catch (e) {
          console.log(e);
        }
      })
    },

    resetForm() {
      this.$refs.form.resetFields();
      this.formData.status = "toHandle";
    },

    handleShowDialog(params) {
      this.currentRow = {...params};
      this.formData = {...params};
      this.showDialog = true;
    },
  },
  computed: {
    content() {
      const item = REPORT_TYPE[this.formData.type];
      if(!item) return "";
      return this.formData[item.contentKey];
    },
    reportLabel() {
      const item = REPORT_TYPE[this.formData.type];
      if(!item) return this.$t('举报内容');
      return this.$t(item.label);
    },

    picList() {
      const item = REPORT_TYPE[this.formData.type];
      if(!item || !item.picKey) return [];
      let pic = this.formData[item.picKey];
      pic = pic ? pic.split(",") : [];
      return pic.map(i => {
        return this.$api.file.downloadImg + i;
      })
    }
  }
}
</script>

<style scoped>

/deep/ .el-dialog {
  width: 650px;
  border-radius: 10px;
}


</style>
